import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Rise, EASE } from "./Reveal";
import { Field } from "./Field";
import { COPY } from "../content/copy";
import { api } from "../lib/api";
import { track } from "../lib/track";

// email in cambio del PDF: il contatto arriva a noi, poi analisi e chiamata
const Scarica = ({ id }) => {
    const d = COPY.anteprima.download;
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle");
    const [href, setHref] = useState(null);
    const submit = async (e) => {
        e.preventDefault();
        if (state === "sending") return;
        setState("sending");
        try {
            const r = await fetch(api("/lead"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mode: "esempio", url: "", email, position: id }),
            });
            if (!r.ok) throw new Error("lead");
            const { download_token } = await r.json();
            track("form_submit", { mode: "esempio" });
            const url = api(`/esempio.pdf?t=${encodeURIComponent(download_token)}`);
            setHref(url);
            setState("done");
            track("esempio_download", { position: id });
            window.open(url, "_blank", "noopener");
        } catch {
            setState("error");
        }
    };
    return (
        <div className="scarica" data-testid={`${id}-scarica`}>
            <p className="scarica-title">{d.title}</p>
            {state === "done" ? (
                <p className="scarica-done" data-testid={`${id}-scarica-done`}>
                    {d.done} <a className="tlink" href={href} target="_blank" rel="noreferrer" data-testid={`${id}-scarica-open`}>{d.open}</a>
                </p>
            ) : (
                <>
                    <p className="scarica-text">{d.text}</p>
                    <form className="scarica-form" onSubmit={submit} autoComplete="on">
                        <Field id={`${id}-scarica-email`} name="email" label={d.emailLabel} value={email} onChange={setEmail} type="email" required testId={`${id}-scarica-email`} autoComplete="email" />
                        <button className="btn scarica-btn" type="submit" disabled={state === "sending"} data-testid={`${id}-scarica-submit`}>
                            {state === "sending" ? d.sending : d.cta}
                        </button>
                    </form>
                    {state === "error" && <p className="caption form-error" data-testid={`${id}-scarica-error`}>{d.error}</p>}
                </>
            )}
        </div>
    );
};

// il foglio d'esempio dell'analisi, da sfogliare pagina per pagina
export const Anteprima = ({ id = "anteprima", compact = false }) => {
    const a = COPY.anteprima;
    const [i, setI] = useState(0);
    const [dir, setDir] = useState(1);
    const n = a.pages.length;
    const go = (d) => {
        const next = (i + d + n) % n;
        setDir(d);
        setI(next);
        track("anteprima_page", { page: next + 1, id });
    };
    const p = a.pages[i];

    return (
        <Rise delay={0.2} className={`anteprima ${compact ? "compact" : ""}`}>
            {!compact && (
                <>
                    <p className="caption">{a.caption}</p>
                    <p className="anteprima-title">{a.title}</p>
                </>
            )}
            <div className="sheet" data-testid={`${id}-sheet`} aria-live="polite">
                <div className="sheet-head">
                    <span className="caption">{p.kicker}</span>
                    <span className="caption" data-testid={`${id}-page`}>{a.pageLabel(i + 1, n)}</span>
                </div>
                <AnimatePresence mode="wait" initial={false}>
                    <motion.div key={i} className="sheet-body"
                        initial={{ opacity: 0, x: 24 * dir }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -24 * dir }}
                        transition={{ duration: 0.45, ease: EASE }}>
                        <p className="sheet-title">{p.title}</p>
                        {p.body && p.body.map((t) => <p className="sheet-p" key={t}>{t}</p>)}
                        {p.items && (
                            <ol className="sheet-list">
                                {p.items.map((t, k) => (
                                    <li key={t}><span className="sheet-num">{String(k + 1).padStart(2, "0")}</span><span>{t}</span></li>
                                ))}
                            </ol>
                        )}
                        {p.closing && <p className="sheet-closing">{p.closing}</p>}
                    </motion.div>
                </AnimatePresence>
                <div className="sheet-nav">
                    <button type="button" className="sheet-btn" onClick={() => go(-1)} disabled={i === 0} data-testid={`${id}-prev`}>← {a.prev}</button>
                    <span className="sheet-dots" aria-hidden="true">
                        {a.pages.map((_, k) => <span key={k} className={`sheet-dot ${k === i ? "on" : ""}`} />)}
                    </span>
                    <button type="button" className="sheet-btn" onClick={() => go(1)} disabled={i === n - 1} data-testid={`${id}-next`}>{a.next} →</button>
                </div>
            </div>
            <Scarica id={id} />
        </Rise>
    );
};
